/**
 * @typedef {import('@/types/models').PaginatedResponse<Resource>} PaginatedResponse
 * @template Resource
 */
/** @typedef {import('@/types/models').Notification} Notification */
/** @typedef {import('@/types/models').NotificationSummary} NotificationSummary */

import axios from '@/utils/axios'

/**
 * @returns {Promise<NotificationSummary>}
 */
export async function fetchNotificationSummary() {
  const response = await axios.get('/xhr/notification/summary')
  return response.data
}

/**
 * @param {object} [params]
 * @returns {Promise<PaginatedResponse<Notification>>}
 */
export async function fetchNotifications(params = {}) {
  const response = await axios.get('/xhr/notification', { params })
  return response.data
}

/**
 * @param {number} notificationId
 * @returns {Promise<Notification>}
 */
export async function fetchNotification(notificationId) {
  const response = await axios.get(`/xhr/notification/${notificationId}`)
  return response.data
}

/**
 * @param {number[]} notificationIds
 * @returns {Promise<NotificationSummary>}
 */
export async function markNotificationsAsRead(notificationIds) {
  const response = await axios.post(`/xhr/notification/mark_as_read?ids=${notificationIds.join(',')}`)
  return response.data
}
